module.exports = __webpack_public_path__ + "static/media/14UNEP20.b13409d0.jpg";